import React, { useEffect, useState } from 'react'
import {FaUserCircle} from "react-icons/fa"
import { dashbordClient } from "./dashbordClient"
import {AiOutlineCaretDown , AiOutlineReload, AiFillShopping , AiFillCaretRight } from "react-icons/ai"
import "./clients.css"
import {IoMdNotificationsOutline} from "react-icons/io"
import {AiOutlineShoppingCart } from "react-icons/ai"
import {FaSearch} from "react-icons/fa"
import ListMedicaments from '../allMedicaments/ListMedicaments'
import MedicamentsEnCours from '../allMedicaments/MedicamentsEnCours'
import MedicamentsLivres from '../allMedicaments/MedicamentsLivres'
import { countCommande, listCommande } from '../allMedicaments/listeCommandeMedicaments'
import Panier from './Panier'
import { Link, Route, Routes, useNavigate } from 'react-router-dom'
import { connected, currentUser } from '../../util/currentUser'
import BarTopClient from './BarTopClient'
export default function Client() {

    const navigate = useNavigate()

    useEffect(()=>{
        if(connected===false){
            navigate("/Connexion")
        }
    },[])


    const sideBarClient = ()=>{
        
        return dashbordClient.map((item , index)=>{
            return(
                <li key={index} className="navbar-item">
                    <p  data-bs-toggle="collapse" data-bs-target={"#"+ item.cName} aria-expanded="false" aria-controls="collapseExample">
                        {item.title} <span className='float-end'>{ item.titleIcon }</span>
                    </p>
                    <div className='collapse' id={item.cName}>
                        {
                            <div className='bg-white border rounded mb-2' key={index}>  
                                {item.content.map((content, index)=>{
                                    return(                  
                                        <p key={index} className='m-0 ps-3 w-100 border' >
                                            <Link to={content.path} className='nav-link'>
                                                {content.icon} {content.contentText }
                                            </Link>
                                        </p>               
                                    )
                                })}
                            </div>
                        }
                    </div>
                </li>
            )
        })
    }


  return (
    <div>
        <div className="container-fluid ">

            <div className="row">
                <div className="col-md-3 col-sm-4 pt-3 bg-primary text-white " style={{minHeight:"100vh"}}>
                    <div className="user-info text-center">
                        {/* <FaUserCircle className='fs-1' /> */}
                        <img src={currentUser.imgSrc} alt="" className=' rounded-circle' style={{width:"60px", height:"60px"}}/>
                        <p className='py-1'>Hello, {currentUser.userName} <span><AiOutlineCaretDown /></span></p>
                        
                    </div>
                    <ul className='navbar-nav ps-3 '>
                        {sideBarClient()}
                    </ul>
                </div>

                <div className='col-md-9 col-sm-8'>
                    <BarTopClient />
                    {/* <CommandesList></CommandesList> */}
                    <Routes>
                        {
                            dashbordClient.map(item=>{
                                return item.content.map(content=>{
                                    return <Route path={content.path+"/*"} element={content.destination}></Route>
                                })
                            })
                        }
                    </Routes>
                </div>

            </div>
          
        </div>
    </div>
  )
}
